import { useRef } from 'react'

import DownArrow from '../../icons/downArrow.inline.svg'

import styles from './nativeSelect.module.scss'

interface NativeSelectProps<V = string> {
  options: { label: string; value: V }[]
  onChange: (value: V) => void
  selectedValue?: V
  placeholder?: string
}

const NativeSelect = ({ options, onChange, selectedValue, placeholder }: NativeSelectProps) => {
  const selectRef = useRef<HTMLSelectElement | null>(null)

  return (
    <div className={styles.selectWrapper}>
      <select
        className={styles.select}
        ref={selectRef}
        value={selectedValue}
        onChange={event => {
          onChange(event.target.value)
        }}
      >
        {placeholder && (
          <option value="" disabled>
            {placeholder}
          </option>
        )}
        {options.map(option => {
          return (
            <option key={String(option.value)} value={String(option.value)}>
              {option.label}
            </option>
          )
        })}
      </select>
      <DownArrow className={styles.arrow} />
    </div>
  )
}

export default NativeSelect
